import axios from "axios";

export const AXIOS = axios.create({
  baseURL: `${process.env.VUE_APP_ENDPOINT_API_URI}/public/auth/login`,
  defaults: {
    headers: {
      common: { Accept: "application/json" }
    }
  }
});
